import { React, useRef, useState } from "react";
import TextField from "../../Components/customComponents/customTextField";
import Select from "../../Components/customComponents/customSelect";
import { useSelector, useDispatch } from "react-redux";
import { updateEmployeeDetails,updateErrorState } from "../../store/reducers/addEmployeeSlice";
import { upload_file_to_s3, validateMobileNumber } from "../../utils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../css/countrycodedropdown.css";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CachedIcon from '@mui/icons-material/Cached';
import { toast } from "react-toastify";


const options = [{value:"MALE",label: "Male"} , {value:"FEMALE",label:"Female"}, {value:"DO_NOT_WANT_TO_DISCLOSE",label:"Do not want to disclose"}];

const EmployeePosition = ({isInvite}) => {
  const empState = useSelector((state) => state.addEmployee.employeeDetails);
  const errorState = useSelector((state)=>state.addEmployee.errorState);
  const feildDisabled = useSelector((state) => state.addEmployee.feildsDisabled);
  const errorMessageState = useSelector((state)=>state.errorMessage.errorMessage);
  const {isViewedEMployee} = useSelector((state) => state.addEmployee);

  const dispatch = useDispatch();
  const [docLoader,setDocLoader] = useState({
    aadharcard: false,
    pancard: false,
  });
  const aadharDocRef = useRef(null);
  const panDocRef = useRef(null);

  const aadharDocument = empState.personalDetails.additionalInformation?.aadharDocument;
  const panDocument = empState.personalDetails.additionalInformation?.panDocument;

  const maritalStatusOptions = [
    { value: "SINGLE", label: "SINGLE" },
    { value: "MARRIED", label: "MARRIED" },
    { value: "DIVORCED", label: "DIVORCED" },
    { value: "SEPARATED", label: "SEPARATED" },
    { value: "WIDOWED", label: "WIDOWED" },
  ];

  const handleSelectChange = (e) => {
    dispatch(
      updateEmployeeDetails({ value: e.target.value, path: e.target.name })
    );
  };

  const handlePhoneInputChange = (value, name) => {
    const phoneNumberPattern = /^\d{8,15}$/
    let isValid = phoneNumberPattern.test(value);
    dispatch(
      updateEmployeeDetails({
        value: value,
        path: `employeeDetails.personalDetails.${name}`
      })
    )
  };

  const handlePhoneInputBlurEvent = (value, name) => {
    dispatch(
      updateEmployeeDetails({
        value: value,
        path: `employeeDetails.personalDetails.${name}`,
      })
    );
    const validMobile = validateMobileNumber(value);
    if (name == "primaryContactNo") {
      dispatch(
        updateErrorState({ activeTab: 1, field: "primaryContactNumber" })
      );
    }

    if (name == "emergencyContactNo") {
      dispatch(
        updateErrorState({ activeTab: 1, field: "emergencyContactNumber" })
      );
    }
  };

  const handleChange = (e) => {
    if (
      e.target.name == "employeeDetails.personalDetails.dob" ||
      e.target.name == "employeeDetails.professionalDetails.dateofJoining" ||
      e.target.name == "employeeDetails.professionalDetails.confirmationDate"
    ) {
      dispatch(
        updateEmployeeDetails({
          value: new Date(e.target.value).toISOString(),
          path: e.target.name,
        })
      );
      // dispatch(
      //   updateEmployeeDetails({
      //     value: empLatestId.employeeId,
      //     path: "employeeDetails.professionalDetails.employeeId",
      //   })
      // );
    } else if (
      e.target.name == "employeeDetails.personalDetails.aadharNumber"
    ) {
      if (/^\d+$/.test(e.target.value) && e.target.value.length < 13) {
        dispatch(
          updateEmployeeDetails({ value: e.target.value, path: e.target.name })
        );
      }
      if (e.target.value.length == 0) {
        dispatch(
          updateEmployeeDetails({ value: e.target.value, path: e.target.name })
        );
      }
    } else {
      dispatch(
        updateEmployeeDetails({ value: e.target.value, path: e.target.name })
      );
    }
  };

  const handleOptionSelect = (e) => {
    if (e.target.value == "OTHER") {
      dispatch(
        updateEmployeeDetails({
          value: "DO_NOT_WANT_TO_DISCLOSE",
          path: e.target.name,
        })
      );
    } else {
      dispatch(
        updateEmployeeDetails({ value: e.target.value, path: e.target.name })
      );
    }
  };

  const handleDocUpload = async (e,docName) => {
    setDocLoader({
      ...docLoader,
      [docName.toLowerCase().replace(" ", "")]: true,
    });
    const file = e.target.files[0];

    if(!file){
      toast.error("please select a file");
      setDocLoader({
        ...docLoader,
        [docName.toLowerCase().replace(" ", "")]: false,
      });
      return
    }
    
    const file_to_upload = file;
    let awsS3uploadedDTO;
    const maxSizeInBytes = 10 * 1024 * 1024; // max 10mb

    if (file_to_upload?.size > maxSizeInBytes) {
      toast.error("File size limit is 10Mb");
        setDocLoader({
        ...docLoader,
        [docName.toLowerCase().replace(" ", "")]: false,
      });
      return
    }

    try {
      const s3path = await upload_file_to_s3(file);
      awsS3uploadedDTO=s3path?.data?.data;
        setDocLoader({
        ...docLoader,
        [docName.toLowerCase().replace(" ", "")]: false,
      });
      let fileData = {
        fileName: file_to_upload.name,
        name: docName,
        resourceName: "", // You can set the file url as needed
        uploadDate: new Date().toISOString(),
        comment: "",
        extension: file_to_upload.name.split(".").pop(), // Extract file extension
        s3Document: awsS3uploadedDTO,
      };
      dispatch(
        updateEmployeeDetails({ value: fileData, path: e.target.name })
      );
    } catch (err) {
        setDocLoader({
        ...docLoader,
        [docName.toLowerCase().replace(" ", "")]: false,
      });
      console.error(err);
    }
  };

  return (
    <>
      <h1 className="text-2xl mb-10">Step 2:PERSONAL DETAILS</h1>
      <div className="flex">
      <div className="flex flex-col justify-center items-end w-[40%]">

        <TextField
          name="employeeDetails.personalDetails.aadharNumber"
          value={empState.personalDetails.aadharNumber}
          label="Aadhar Number"
          type="text"
          onChange={handleChange}
          isMandatory={true}
          disabled={feildDisabled || isViewedEMployee}
          error={errorState.step1.aadhar ? errorState.step1.aadhar : ""}
          onBlur={() => {
            dispatch(updateErrorState({ activeTab: 1, field: "aadhar" }));
          }}
          className={`${
            empState.personalDetails.aadharNumber === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />

        <div className="flex mb-4 relative">
          <p className="text-sm font-medium text-gray-700 mr-5 my-auto">
            Upload Aadhar<span className="text-red-500 text-xl">*</span>
          </p>
          <div className="w-60">
            <input
              type="file"
              ref={aadharDocRef}
              accept=".pdf,.jpg,.jpeg,.png"
              name="employeeDetails.personalDetails.additionalInformation.aadharDocument"
              disabled={isViewedEMployee}
              onChange={(e) => handleDocUpload(e,'Aadhar Card')}
              className="hidden"
            /> 
            {aadharDocument?.fileName ? (
              <div className="flex items-center justify-between">
                <span>
                  {aadharDocument
                    .fileName.length > 25
                    ? aadharDocument.fileName.slice(
                        0,
                        22
                      ) + "..."
                    : aadharDocument.fileName}
                </span>
                {
                  !feildDisabled && (
                    <button onClick={() => aadharDocRef.current.click()}>
                      <CachedIcon style={{ color: "#1976D2" }} />
                    </button>
                  )
                }
              </div>
            ) : (
              <button onClick={() => aadharDocRef.current.click()}>
                <UploadFileIcon style={{ color: "#1976D2" }} /> Upload File
              </button>
            )}
          </div>
          {docLoader.aadharcard && <div className="loader border-4 border-t-4 border-gray-200 border-t-blue-600 rounded-full w-6 h-6 animate-spin mx-auto absolute -right-8 top-1"></div>}
        </div>
        
        <TextField
          name="employeeDetails.personalDetails.panNumber"
          value={empState.personalDetails.panNumber}
          label="PAN Number"
          type="text"
          onChange={handleChange}
          error={errorState.step1.pan ? errorState.step1.pan : ""}
          isMandatory={true}
          disabled={feildDisabled || isViewedEMployee}
          onBlur={() => {
            dispatch(updateErrorState({ activeTab: 1, field: "pan" }));
          }}
          className={`${
            empState.personalDetails.panNumber === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />

        <div className="flex mb-4 relative">
          <p className="text-sm font-medium text-gray-700 mr-5 my-auto">
            Upload Pan<span className="text-red-500 text-xl">*</span>
          </p>
          <div className="w-60">
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              name="employeeDetails.personalDetails.additionalInformation.panDocument"
              ref={panDocRef}
              onChange={(e) => handleDocUpload(e,'Pan Card')}
              disabled={isViewedEMployee}
              className="hidden"
            />   
            {panDocument
              ?.fileName ? (
              <div className="flex items-center justify-between">
                <span>
                  {panDocument
                    .fileName.length > 25
                    ? panDocument.fileName.slice(
                        0,
                        22
                      ) + "..."
                    : panDocument.fileName}
                </span>
                
                {!feildDisabled && (
                  <button onClick={() => panDocRef.current.click()}>
                    <CachedIcon style={{ color: "#1976D2" }} />
                  </button>
                )}
              </div>
            ) : (
              <button onClick={() => panDocRef.current.click()}>
                <UploadFileIcon style={{ color: "#1976D2" }} /> Upload File
              </button>
            )}
          </div>
          {docLoader.pancard && <div className="loader border-4 border-t-4 border-gray-200 border-t-blue-600 rounded-full w-6 h-6 animate-spin mx-auto absolute -right-8 top-1"></div>}
        </div>
        
        <TextField
          name="employeeDetails.personalDetails.email"
          label="Email"
          type="email"
          onChange={handleChange}
          value={empState.personalDetails.email}
          isMandatory={true}
          disabled={isInvite || isViewedEMployee}
          error={
            errorState.step1.personalEmail ? errorState.step1.personalEmail : ""
          }
          onBlur={() => {
            dispatch(updateErrorState({ activeTab: 1, field: "email" }));
          }}
          className={`${
            empState.personalDetails.email === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />
        <TextField
          name="employeeDetails.personalDetails.dob"
          label="Date of Birth"
          type="date"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          isMandatory={true}
          value={
            empState.personalDetails.dob
              ? empState.personalDetails.dob.split("T")[0]
              : ""
          }
          max={new Date().toISOString().split("T")[0]}
        />
        <Select
          name="employeeDetails.personalDetails.gender"
          label="Gender"
          options={options}
          onChange={handleOptionSelect}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.gender}
          isMandatory={true}
          className={`${
            empState.personalDetails.gender === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />
        {/* <TextField
          name="employeeDetails.personalDetails.primaryContactNo"
          label="Mobile Number"
          type="tel"
          onChange={handleChange}
          value={empState.personalDetails.primaryContactNo}
          isMandatory={true}
        /> */}
        <div className="flex ">
          <p className="text-sm font-medium text-gray-700 mr-5 my-auto">
            Mobile Number<span className="text-red-500 text-xl">*</span>
          </p>
          <div>
            <CustomPhoneInput
              name="primaryContactNo"
              value={empState.personalDetails.primaryContactNo}
              onPhoneInputChange={handlePhoneInputChange}
              phoneBlurEvent={handlePhoneInputBlurEvent}
              customPlaceholder="Mobile Number"
              disabled={feildDisabled || isViewedEMployee}
              className={`${
                empState.personalDetails.primaryContactNo === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
            {errorState.step1.primaryContactNumber && (
              <p className="text-red-500 text-sm italic">
                {errorState.step1.primaryContactNumber}
              </p>
            )}
          </div>
        </div>
        <TextField
          name="employeeDetails.personalDetails.emergencyContactName"
          label="Emergency Contact Name"
          type="text"
          onChange={handleChange}
          value={empState.personalDetails.emergencyContactName}
          isMandatory={true}
          error={
            errorState.step1.emergencyContactName
              ? errorState.step1.emergencyContactName
              : ""
          }
          disabled={feildDisabled || isViewedEMployee}
          onBlur={() => {
            dispatch(
              updateErrorState({ activeTab: 1, field: "emergencyContactName" })
            );
          }}
          className={`${
            empState.personalDetails.emergencyContactName === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />
        {/* <TextField
          name="employeeDetails.personalDetails.emergencyContactNo"
          label="Emergency Contact Number"
          type="tel"
          onChange={handleChange}
          value={empState.personalDetails.emergencyContactNo}
          isMandatory={true}
        /> */}
        <div className="flex">
          <p className="text-sm font-medium text-gray-700 mr-5 my-auto">
            Emergency Contact Number{""}
            <span className="text-red-500 text-xl">*</span>
          </p>
          <div>
            <CustomPhoneInput
              name="emergencyContactNo"
              value={empState.personalDetails.emergencyContactNo}
              onPhoneInputChange={handlePhoneInputChange}
              customPlaceholder="Emergency Contact Number"
              phoneBlurEvent={handlePhoneInputBlurEvent}
              disabled={feildDisabled || isViewedEMployee}
              className={`${
                empState.personalDetails.emergencyContactNo === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
            {errorState.step1.emergencyContactNumber && (
              <p className="text-red-500 text-sm italic">
                {errorState.step1.emergencyContactNumber}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-end w-[50%]">
      <TextField
          name="employeeDetails.personalDetails.fatherName"
          label="Father's Name"
          type="text"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.fatherName}
          isMandatory={true}
          className={`${
            empState.personalDetails.fatherName === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />
      <Select
          label="Marital Status"
          name="employeeDetails.personalDetails.maritalStatus"
          options={maritalStatusOptions}
          value={empState.personalDetails.maritalStatus}
          onChange={handleSelectChange}
          disabled={feildDisabled || isViewedEMployee}
          isMandatory={true}
          className={`${
            empState.personalDetails.maritalStatus === "" &&
            errorMessageState === true &&
            "border border-red-500"
          }`}
        />
      <TextField
          name="employeeDetails.personalDetails.spouseName"
          label="Spouse Name"
          type="text"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.spouseName}
        />
        <TextField
          name="employeeDetails.personalDetails.hobbies"
          label="Hobbies"
          type="text"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.hobbies}
        />
        <TextField
          name="employeeDetails.personalDetails.height"
          label="Height"
          type="text"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.height}
        />
        <TextField
          name="employeeDetails.personalDetails.weight"
          label="Weight"
          type="text"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.weight}
        />
        <TextField
          name="employeeDetails.personalDetails.identificationMarks"
          label="Identification Mark"
          type="text"
          onChange={handleChange}
          disabled={feildDisabled || isViewedEMployee}
          value={empState.personalDetails.identificationMarks}
        />
      </div>
      </div>
      
    </>
  );
};

export default EmployeePosition;

export const CustomPhoneInput = ({
  name,
  value,
  onPhoneInputChange,
  customPlaceholder,
  phoneBlurEvent,
  disabled,
  className
}) => {
  return (
    <PhoneInput
      inputClass="border border-gray-300 rounded-2 p-2 focus:outline-none focus:border-blue-500"
      country={"in"}
      value={value}
      onChange={(e) => onPhoneInputChange(e, name)}
      onBlur={(e)=>phoneBlurEvent(e.target.value,name)}
      placeholder={customPlaceholder}
      className={`my-3 ${className}`}
      containerStyle={{width:"15rem"}}
      inputStyle={{height:40}}
      dropdownStyle={{width:"15rem"}}
      disabled={disabled}
    />
  );
}